import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class IntegracaoErpClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async listar(params = {}) {
    try {
      const cleaned = {};
      Object.entries(params).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') cleaned[k] = v;
      });
      return await this.api.get('/integracoes-erp', { params: cleaned });
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async buscarPorId(id) {
    try {
      return await this.api.get(`/integracoes-erp/${id}`);
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async criar(payload) {
    try {
      return await this.api.post('/integracoes-erp', payload);
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async atualizar(id, payload) {
    try {
      return await this.api.put(`/integracoes-erp/${id}`, payload);
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async excluir(id) {
    try {
      return await this.api.delete(`/integracoes-erp/${id}`);
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async testar(id) {
    try {
      return await this.api.post(`/integracoes-erp/${id}/testar`);
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async testarAdHoc(payload) {
    try {
      return await this.api.post('/integracoes-erp/testar', payload);
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }
}
